export default Object.freeze({
  REGULAR: 'Regular',
  EDUCATIONAL: 'Educativo',
  THERAPY: 'Terapia',
});
